import * as runtime from '@/api/runtime'
import {
  BatchReturnDbUpdateRequest,
  BatchReturnDbUpdateRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchReturnDbUpdateCondition,
  BatchReturnDbUpdateConditionFromJSON
} from '@/api/models/batch/BatchReturnDbUpdateCondition'

/**
 * 帳票作成
 */
export class BatchReturnDbUpdateApi extends runtime.BaseAPI {
  async return(request: BatchReturnDbUpdateRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/return/return-db-update`,
      BatchReturnDbUpdateRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchReturnDbUpdateCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchReturnDbUpdateConditionFromJSON(jsonValue)
    ).value()
  }
}
